<div>
  <div *ngIf="!is_online" class="d-flex flex-column align-items-center justify-content-center position-relative" style="height: 100vh;top: -30px;">
    <img src="assets/svg-images/error_img.svg" alt="" class="">
    <ion-text class="fs-24 fw-8 sitefontbold mt-4">No Internet connection</ion-text>
  </div>
  <div *ngIf="is_online">
    <ion-router-outlet></ion-router-outlet>
  </div>
</div>